module.exports = __webpack_public_path__ + "static/media/bosque1.56966819.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pic-collage/bosque1.jpg
// module id = 190
// module chunks = 0